const CLIENT_LOGGING_ENABLED = import.meta.env.REACT_APP_CLIENT_LOGGING === "true";

export const logger = {
  log: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.log(...data);
    }
  },
  info: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.info(...data);
    }
  },
  error: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.error(...data);
    }
  },
  dir: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.dir(...data);
    }
  },
  warn: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.warn(...data);
    }
  },
  table: (...data: any) => {
    if (CLIENT_LOGGING_ENABLED) {
      console.table(...data);
    }
  },
};
